// Side-effect module: calling `initSentry()` at top level means any
// file that imports THIS module runs Sentry.init as part of resolving
// the import. In ES module semantics, that runs before the next
// `import` statement is fetched — which is exactly what we need to
// guarantee Sentry is live before App.tsx's top-level
// `wrapRootComponent(App)` executes.
//
// Do not add any other code here. Keep the import surface trivial so
// the execution order stays obvious.

import { initSentry } from './sentry';

initSentry();
